"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HcfConfig = void 0;
var _defaultIcons = require("../../defaults/productTable/defaultIcons");
var _defaultCoverDisplayOptions = require("../../defaults/quoteTools/defaultCoverDisplayOptions");
var _defaultCustomRouteDefinitions = require("../../defaults/quoteTools/defaultCustomRouteDefinitions");
var _defaultStepDefinitions = require("../../defaults/quoteTools/defaultStepDefinitions");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _hcfQuoteToolContext = require("./quoteTools/hcfQuoteToolContext");
var _hcfAboutOwner = require("./quoteTools/hcfAboutOwner");
var _hcfSuccess = require("./quoteTools/hcfSuccess");
var _hcfThemeContext = require("./hcfThemeContext");
var _hcfAboutPet = require("./quoteTools/hcfAboutPet");
var _hcfAuthorisedPersonDisplaySettings = require("./quoteTools/hcfAuthorisedPersonDisplaySettings");
var _hcfRegularVetDisplaySettings = require("./quoteTools/hcfRegularVetDisplaySettings");
var _hcfSummary = require("./quoteTools/hcfSummary");
var _hcfStepDefinitions = require("./quoteTools/hcfStepDefinitions");
var _hcfCoverDisplayOptions = require("./quoteTools/hcfCoverDisplayOptions");
var HcfConfig = exports.HcfConfig = {
  theme: _hcfThemeContext.HcfThemeContext,
  quoteTools: {
    themeOverrides: _hcfQuoteToolContext.HcfQuoteToolContext,
    steps: {
      StepDefinitions: _hcfStepDefinitions.HcfStepDefinitions,
      basicOwnerDetails: _hcfAboutOwner.HcfBasicOwnerDetails,
      fullOwnerDetails: _hcfAboutOwner.HcfAboutOwner,
      aboutPet: _hcfAboutPet.HcfAboutPet,
      coverDisplayOptions: _hcfCoverDisplayOptions.HcfCoverDisplayOptions,
      summary: _hcfSummary.HcfSummary,
      success: _hcfSuccess.HCFSuccess,
      bannerStyle: 'bullets',
      showCompletedStepBannerOnPage: ''
    },
    widgets: {
      authorisedPersonDisplaySettings: _hcfAuthorisedPersonDisplaySettings.HcfAuthorisedPersonDisplaySettings,
      regularVetDisplaySettings: _hcfRegularVetDisplaySettings.HcfRegularVetDisplaySettings
    },
    customRouteDefinitions: _defaultCustomRouteDefinitions.DefaultCustomRouteDefinitions,
    staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
    productTable: {
      optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
      staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
      icons: _defaultIcons.defaultIcons
    },
    middlewareApiKeys: {
      "public": {
        sit: {
          applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
          apiKey: '2VD61B46EF909D40749',
          expiry: 3600
        },
        uat: {
          applicationId: '1BFB7E47-3488-4793-8161-18D90D29C087',
          apiKey: '2VD61B46EF909D40749',
          expiry: 3600
        },
        preprod: {
          applicationId: '330DEA3E-0A77-40AE-88AD-8F91026DDC20',
          apiKey: '81904FB7F31A4837A9',
          expiry: 3600
        },
        prod: {
          applicationId: 'A244829A-EB70-4C8F-B1D0-2C7F9C72D41F',
          apiKey: '3FA2A9BB331E447E99',
          expiry: 3600
        }
      }
    },
    recaptchaSiteKey: '6LdtR-skAAAAAGv4CmI_yD5F97jbpn2F5dmWB-ul',
    recaptchaSecretKey: '6LdtR-skAAAAAA6K3A8jCJOOkpu2V_ZbOq7AsoIX',
    recaptchaSiteKeyProd: '6LcCS-skAAAAAEv4ET1FC2cetZbvlfrDtcJwyWIp',
    recaptchaSecretKeyProd: '6LcCS-skAAAAABHxbb9R3yIxfo2-OVKBWzSg1OFL'
  }
};